<template>
  <div
    v-if="isLoading"
    :class="{ 'split-apart': splitApart, 'new-version': newVersion }"
    class="skeleton-summary-container mt-4 mb-3"
  >
    <div
      v-for="n in numberOfMetrics"
      :key="n"
      class="skeleton-summary-section skeleton-summary-divider"
    >
      <DpplSkeletonLoader>
        <h3 class="skeleton-summary-metric mb-1">
          0
        </h3>
      </DpplSkeletonLoader>
      <v-skeleton-loader
        type="text"
        width="65px"
        class="mr-6"
      />
    </div>
  </div>
</template>

<script>

import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';

export default {
  name: 'SummarySkeletonLoader',
  components: {
    DpplSkeletonLoader,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    numberOfMetrics: {
      type: Number,
      default: 4,
    },
    splitApart: {
      type: Boolean,
      default: false,
    },
    newVersion: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
@import '@/less/mixins';
.skeleton-summary-container {
  background: @white;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 140px;
  .shadow();

  &.split-apart {
    background: transparent;
    box-shadow: none;

    &.new-version {
      border-radius: 8px;

      .skeleton-summary-section {
        border-radius: 8px;
        border: 1px solid @stroke-default;
        box-shadow: none;
      }
    }

    .skeleton-summary-section {
      background: @white;
      border-radius: 10px;
      margin: 0px 8px;
      .shadow();
    }

    .skeleton-summary-section:first-of-type {
      margin: 0px 8px 0px 0px;
    }

    .skeleton-summary-section:last-of-type {
      margin: 0px 0px 0px 8px;
    }

    .skeleton-summary-divider {
      border: none;
    }
  }
}

.skeleton-summary-section {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
  padding: 24px;
  position: relative;

  :deep(.v-skeleton-loader__text) {
    margin: 16px 0px;
  }
}

.skeleton-summary-divider {
  border-right: 1px solid @stroke-default;
}

.skeleton-summary-metric {
  color: @grey-500;
}

</style>
